import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCustomerSpeditions from './ReportCustomerSpeditions'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCustomerSpeditions} />
    </Switch>
)

export default Components
